import React from 'react';

export default function Disclaimer({ style }) {
  return (
    <p style={{ ...s.disclaimer, ...style }}>
      <strong>Disclaimer:</strong> The content on this page is for educational purposes only and is not financial, investment, tax, or legal advice. Always consult a qualified financial professional before making financial decisions.
    </p>
  );
}

const s = {
  disclaimer: {
    marginTop: '48px',
    padding: '14px 18px',
    background: 'rgba(100,116,139,0.06)',
    border: '1px solid #1e293b',
    borderRadius: '10px',
    fontSize: '12px',
    color: '#475569',
    lineHeight: 1.6,
    maxWidth: '900px',
    margin: '48px auto 0',
  },
};
